import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IMyFavourite, defaultValue } from 'app/shared/model/my-favourite.model';

export const ACTION_TYPES = {
  FETCH_MYFAVOURITE_LIST: 'myFavourite/FETCH_MYFAVOURITE_LIST',
  FETCH_MYFAVOURITE: 'myFavourite/FETCH_MYFAVOURITE',
  CREATE_MYFAVOURITE: 'myFavourite/CREATE_MYFAVOURITE',
  UPDATE_MYFAVOURITE: 'myFavourite/UPDATE_MYFAVOURITE',
  DELETE_MYFAVOURITE: 'myFavourite/DELETE_MYFAVOURITE',
  RESET: 'myFavourite/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMyFavourite>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type MyFavouriteState = Readonly<typeof initialState>;

// Reducer

export default (state: MyFavouriteState = initialState, action): MyFavouriteState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MYFAVOURITE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MYFAVOURITE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MYFAVOURITE):
    case REQUEST(ACTION_TYPES.UPDATE_MYFAVOURITE):
    case REQUEST(ACTION_TYPES.DELETE_MYFAVOURITE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MYFAVOURITE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MYFAVOURITE):
    case FAILURE(ACTION_TYPES.CREATE_MYFAVOURITE):
    case FAILURE(ACTION_TYPES.UPDATE_MYFAVOURITE):
    case FAILURE(ACTION_TYPES.DELETE_MYFAVOURITE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MYFAVOURITE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MYFAVOURITE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MYFAVOURITE):
    case SUCCESS(ACTION_TYPES.UPDATE_MYFAVOURITE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MYFAVOURITE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/my-favourites';

// Actions

export const getEntities: ICrudGetAllAction<IMyFavourite> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_MYFAVOURITE_LIST,
  payload: axios.get<IMyFavourite>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IMyFavourite> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MYFAVOURITE,
    payload: axios.get<IMyFavourite>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IMyFavourite> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MYFAVOURITE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IMyFavourite> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MYFAVOURITE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IMyFavourite> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MYFAVOURITE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
